/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChartData {
    getFixupPrototypeFunction() { return AgentChartData.fixupPrototype; }

    static newInstance(model: Partial<AgentChartData>): AgentChartData {
        let obj = Object.assign(new AgentChartData(), model);
        AgentChartData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChartData>): AgentChartData {
        if (!model) return null;
        return AgentChartData.newInstance(<AgentChartData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChartData) {
        if (!obj) return;

        models.AgentChartData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChartData): boolean {
        Object.setPrototypeOf(obj, AgentChartData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.x_axis) {
            models.AgentChatAxis.fixupPrototype(this.x_axis);
        }
        if (this.y_axis) {
            models.AgentChatAxis.fixupPrototype(this.y_axis);
        }
        if (this.group_by) {
            models.AgentChartGroupBy.fixupPrototype(this.group_by);
        }
    }

    /**
     * Type of the charts
     */
    types: Array<models.ChartType>;

    /**
     * Title of the chart
     */
    title: string;

    /**
     * Sub Title of the chart
     */
    sub_title: string;

    /**
     * X Axis of the chat
     */
    x_axis: models.AgentChatAxis;

    /**
     * Y Axis of the chat
     */
    y_axis: models.AgentChatAxis;

    /**
     * Group by of the chart
     */
    group_by: models.AgentChartGroupBy;

    /**
     * Data of the chat
     */
    data: any;

}
